import './index.css';
import ServicesSubMenu from '../ServicesSubMenu';
import lesRogersScreenshot from '../../assets/images/portfolio/les-rogers-inc-home.webp';
import beYouScreenshot from '../../assets/images/portfolio/beyou-studio-23-salon-home.webp';

const websiteProjects = [
  {
    name: 'Les Rogers, Inc.',
    url: 'https://lesrogersinc.com',
    screenshot: lesRogersScreenshot,
    description:
      'A local excavating and materials company website for Northwest Arkansas projects, with service details, project work, company information, and contact paths.',
  },
  {
    name: 'Be You Studio 23 Salon',
    url: 'https://beyoustudio23salon.com',
    screenshot: beYouScreenshot,
    description:
      'A neighborhood salon website for Springdale, Arkansas, featuring the team, salon services, location details, social links, and booking-friendly contact options.',
  },
];

const websiteServices = [
  {
    title: 'Static Website',
    description:
      'An entry-level professional web presence with a contact page that links directly to your email. This package can be linked to Google, includes search engine optimization, is cached in the cloud for very fast loading, and keeps monthly hosting fees low.',
  },
  {
    title: 'SMS Messaging',
    description:
      'Set your business up with SMS messaging so customers can stay in touch, ask questions, receive updates, and keep communication moving from your website.',
  },
  {
    title: 'Scheduling Support',
    description:
      'Add scheduling paths that help customers request appointments, start bookings, or connect with your existing calendar and business workflow.',
  },
  {
    title: 'Customer Communication',
    description:
      'Connect forms, calls, texts, and follow-up workflows so your website becomes a practical communication hub instead of a static page.',
  },
  {
    title: 'Customer Login',
    description:
      'Give customers a secure place to sign in, manage their profile, view account details, and connect more deeply with your business online.',
  },
  {
    title: 'E-Commerce and Payment Provider Integration',
    description:
      'Add product pages, checkout flows, payment provider integrations, and ordering paths that help customers buy or request services directly from your site.',
  },
  {
    title: 'Friendly Chatbots',
    description:
      'Add a friendly chatbot that can answer common questions, guide visitors to the right page, and help customers make contact when they need support.',
  },
  {
    title: 'AI Integrated Intelligent Chatbots',
    description:
      'Use AI-powered chatbots connected to your business information to provide smarter answers, qualify requests, and support more useful customer conversations.',
  },
];

const ServicesWebsites = () => {
  return (
    <div className="services-placeholder-page">
      <ServicesSubMenu />
      <section className="services-placeholder-hero">
        <p className="services-placeholder-kicker">Hogcloud Services</p>
        <h1>Websites</h1>
        <p>
          Custom websites for small businesses, local brands, and service
          providers. Hogcloud builds practical, mobile-friendly sites with clear
          messaging, static website options, SMS communication, scheduling
          support, customer logins, e-commerce, chatbots, and room to grow.
        </p>
      </section>

      <section className="website-services" aria-labelledby="website-services-title">
        <div className="website-projects-header">
          <p className="services-placeholder-kicker">Website Services</p>
          <h2 id="website-services-title">From static sites to intelligent customer tools</h2>
        </div>

        <div className="website-service-grid">
          {websiteServices.map((service) => (
            <article className="website-service-card" key={service.title}>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="website-projects" aria-labelledby="website-projects-title">
        <div className="website-projects-header">
          <p className="services-placeholder-kicker">Recent Website Work</p>
          <h2 id="website-projects-title">Local business sites</h2>
        </div>

        <div className="website-project-grid">
          {websiteProjects.map((project) => (
            <article className="website-project-card" key={project.url}>
              <a
                className="website-project-image-link"
                href={project.url}
                target="_blank"
                rel="noreferrer"
                aria-label={`Visit ${project.name}`}
              >
                <img
                  src={project.screenshot}
                  alt={`${project.name} homepage screenshot`}
                  loading="lazy"
                />
              </a>
              <div className="website-project-content">
                <h3>{project.name}</h3>
                <p>{project.description}</p>
                <a href={project.url} target="_blank" rel="noreferrer">
                  Visit site
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ServicesWebsites;
